/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EvmNftActivityListInfo } from '../models/EvmNftActivityListInfo';
import type { EvmNftMintListInfo } from '../models/EvmNftMintListInfo';
import type { EvmNftResult } from '../models/EvmNftResult';
import type { EvmNftTransferListInfo } from '../models/EvmNftTransferListInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class EvmNftControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns EvmNftTransferListInfo OK
     * @throws ApiError
     */
    public getEvmNftTransferList({
        page = 1,
        size = 25,
    }: {
        page?: number,
        size?: number,
    }): CancelablePromise<EvmNftTransferListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/nft/transfer/list',
            query: {
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmNftTransferListInfo OK
     * @throws ApiError
     */
    public getEvmNftTransferList1({
        page = 1,
        size = 25,
    }: {
        page?: number,
        size?: number,
    }): CancelablePromise<EvmNftTransferListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/nft/transfer/list',
            query: {
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmNftActivityListInfo OK
     * @throws ApiError
     */
    public getEvmNftTradeList({
        page = 1,
        size = 25,
    }: {
        page?: number,
        size?: number,
    }): CancelablePromise<EvmNftActivityListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/nft/trade/list',
            query: {
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmNftActivityListInfo OK
     * @throws ApiError
     */
    public getEvmNftTradeList1({
        page = 1,
        size = 25,
    }: {
        page?: number,
        size?: number,
    }): CancelablePromise<EvmNftActivityListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/nft/trade/list',
            query: {
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmNftMintListInfo OK
     * @throws ApiError
     */
    public getEvmNftMintList({
        page = 1,
        size = 25,
    }: {
        page?: number,
        size?: number,
    }): CancelablePromise<EvmNftMintListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/nft/mint/list',
            query: {
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmNftMintListInfo OK
     * @throws ApiError
     */
    public getEvmNftMintList1({
        page = 1,
        size = 25,
    }: {
        page?: number,
        size?: number,
    }): CancelablePromise<EvmNftMintListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/nft/mint/list',
            query: {
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmNftResult OK
     * @throws ApiError
     */
    public getEvmNftCardList(): CancelablePromise<EvmNftResult> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/nft/card/list',
        });
    }

    /**
     * @returns EvmNftResult OK
     * @throws ApiError
     */
    public getEvmNftCardList1(): CancelablePromise<EvmNftResult> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/nft/card/list',
        });
    }

}
